import { request } from '@/api/http';
import type {
  ScrapeAnalyticsBySearchListResponse,
  ScrapeAnalyticsDrilldown,
  ScrapeAnalyticsListParams,
  ScrapeAnalyticsSourceListResponse,
} from '@/api/types/scrapeAnalytics';

function buildQuery(params?: ScrapeAnalyticsListParams): string {
  if (!params) return '';
  const q = new URLSearchParams();
  if (params.search_name) q.set('search_name', params.search_name);
  if (params.source) q.set('source', params.source);
  if (params.status) q.set('status', params.status);
  if (params.category) q.set('category', params.category);
  if (params.started_after) q.set('started_after', params.started_after);
  if (params.started_before) q.set('started_before', params.started_before);
  if (params.limit != null) q.set('limit', String(params.limit));
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const scrapeAnalyticsService = {
  bySource: (params?: ScrapeAnalyticsListParams, opts?: { signal?: AbortSignal }) =>
    request<ScrapeAnalyticsSourceListResponse>(`/analytics/scrape/sources${buildQuery(params)}`, opts),
  bySearch: (params?: ScrapeAnalyticsListParams, opts?: { signal?: AbortSignal }) =>
    request<ScrapeAnalyticsBySearchListResponse>(`/analytics/scrape/by-search${buildQuery(params)}`, opts),
  drilldown: (params: ScrapeAnalyticsListParams & { source: string }, opts?: { signal?: AbortSignal }) =>
    request<ScrapeAnalyticsDrilldown>(`/analytics/scrape/drilldown${buildQuery(params)}`, opts),
};
